export enum RelativeTimezoneDateTypeEnum {
    TODAY = 'TODAY',
    YESTERDAY = 'YESTERDAY',
    THIS_WEEK = 'THIS_WEEK',
    LAST_WEEK = 'LAST_WEEK',
    THIS_MONTH = 'THIS_MONTH',
    LAST_MONTH = 'LAST_MONTH',
    LAST_THREE_MONTHS = 'LAST_THREE_MONTHS',
    LAST_FOUR_MONTHS = 'LAST_FOUR_MONTHS',
    LAST_24_HOURS= 'LAST_24_HOURS',
    LAST_3_DAYS = 'LAST_3_DAYS',
    LAST_7_DAYS = 'LAST_7_DAYS',
    LAST_30_DAYS = 'LAST_30_DAYS',
    LAST_90_DAYS = 'LAST_90_DAYS',
    LAST_QUARTER = 'LAST_QUARTER',
    LAST_FOUR_QUARTERS = 'LAST_FOUR_QUARTERS'
}
